import { combineEpics } from 'redux-observable';

import loginFormEpics from '../components/loginForm/loginForm.epic';
import subscriptionFormEpics from '../components/subscriptionForm/subscriptionForm.epic';
import spectreAppEpics from '../components/spectreApp/spectreApp.epic';
import sideBarEpics from '../components/sideBar/sideBar.epic';
import SettingsEpics from '../components/settings/settings.epic';
import SpecsheetEpics from '../components/specsheet/specsheet.epic';
import bowlersEpics from '../components/bowlers/bowlers.epic';
import arsenalEpics from '../components/arsenal/arsenal.epic';
import syncDeviceModalEpics from '../components/syncDeviceModal/syncDeviceModal.epic';

export const epics = combineEpics(
  loginFormEpics,
  subscriptionFormEpics,
  spectreAppEpics,
  sideBarEpics,
  SettingsEpics,
  SpecsheetEpics,
  bowlersEpics,
  arsenalEpics,
  syncDeviceModalEpics
);
